import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, take } from 'rxjs';

import { connecterPuisRevenir } from '../routing/retour-apres-connexion';

/**
 * Garde de route OIDC. L'état d'authentification est déjà résolu au démarrage par `checkAuth()`
 * (app initializer dans app.config). Ici : si authentifié → on laisse passer ; sinon → on lance
 * le login Keycloak en notant l'adresse demandée, rétablie au retour (`connecterPuisRevenir`).
 * Déterministe (pas de boucle).
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const oidc = inject(OidcSecurityService);
  return oidc.isAuthenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => {
      if (isAuthenticated) {
        return true;
      }
      connecterPuisRevenir(oidc, state.url);
      return false;
    }),
  );
};
